import {Outlet} from 'react-router-dom';
import {LoadingOverlay} from "components/core/loading-overlay";
import {useGetAccount} from "features/profile/hooks/use-account";
import {useEffect} from "react";
import {useCommonStore} from "state/store/common/useCommonStore";
import {useAuthStore} from "state/store/auth/useAuthStore";

export default function UserHolder() {
  const setUser = useCommonStore((state) => (
    state.setUser));
  const user = useCommonStore((state) => (
    state.user));
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // After logout, common store clears `user` while this tree may still be mounted
  // briefly — do not re-enable /iam/me or flash LoadingOverlay.
  const {data, isLoading, isFetching} = useGetAccount({
    enabled: isAuthenticated && !user,
  });
  
  useEffect(() => {
    if (data) {
      setUser(data);
    }
  }, [data, setUser]);

  if (isAuthenticated && !user && (isLoading || isFetching)) {
    return <LoadingOverlay/>;
  }
  
  return (
    <Outlet/>
  );
}
